import React from 'react';
import Icon, { IconProps } from './Icon';

const NoIcon: React.FC<IconProps> = ({ size = 28, color = '#343B91', ...props }) => {
  return (
    <Icon size={size} color={color} viewBox="0 0 28 28" {...props}>
      <rect width="28" height="28" rx="14" fill={color} />
    </Icon>
  );
};

export default NoIcon;

